import styled from '@emotion/styled'

const ScrollPaneContainer = styled.div`
  position: relative;
`
const ScrollPaneContent = styled.div`
  position: relative;
  height: 57px;
  margin: 0;
  padding: 6px 0;
  overflow-x: hidden;
  overflow-y: scroll;
`
const ScrollPaneShadow = styled.div`
  height: 57px;
  position: absolute;
  bottom: 0;
  left: -19px;
  right: -19px;
  box-shadow:
    inset 0 5px 10px 0 white,
    inset 0 -5px 10px 0 white;
  pointer-events: none;
`

export const ScrollPane = props => {
  return (
    <ScrollPaneContainer>
      <ScrollPaneContent>{props.children}</ScrollPaneContent>
      <ScrollPaneShadow />
    </ScrollPaneContainer>
  )
}
